
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProductListAlgolia',
  components: {
    CrossIcon: () => import('~/assets/icons/cross.svg')
  },
  props: {
    requestFacetFilters: {
      type: Array,
      required: true,
    },
    products: {
      type: Array,
      required: true
    },
    desktopIndent: {
      type: String,
      required: false,
      default: 'di--none'
    },
    viewedProducts: {
      type: Number,
      default: 0
    },
    totalProducts: {
      type: Number,
      default: 0
    },
    lookupFinished: {
      type: Boolean,
      default: false
    },
    subCategories: {
      type: Object,
      default: () => ({})
    },
    facets: {
      type: Object,
      required: true
    },
    queryName: {
      type: String,
      required: true
    },
    displayProductCount: {
      type: Boolean,
      default: false
    },
    displaySubNavigation: {
      type: Boolean,
      default: false
    },
    displayFilter: {
      type: Boolean,
      default: false
    },
    limitProducts: {
      type: String,
      required: false,
      default: '0'
    },
    displayLoadMore: {
      type: Boolean,
      default: false
    },
    mobileColumns: {
      type: String,
      required: false,
      default: '2'
    },
    desktopColumns: {
      type: String,
      required: false,
      default: '5'
    },
    isInSearch: {
      type: Boolean,
      required: false,
      default: false,
    },
    enableAddToWishlist: {
      type: Boolean,
      default: false
    },
    enableAddToCart: {
      type: Boolean,
      default: false
    },
    enableProductType: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: null
    },
    emitLoadMore: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      required: false,
      default: ''
    },
    buttonLink: {
      type: Object,
      required: false,
      default: () => ({})
    },
    initialFacets: {
      type: Object,
      default: () => ({})
    },
    mobileProductWrapperMargin: {
      type: String,
      default: 'large'
    },
    desktopProductWrapperMargin: {
      type: String,
      default: 'none'
    },
    queryID: {
      type: String,
      required: true
    },
    requestId: {
      type: String,
      required: true
    },
    isFetching: {
      type: Boolean,
      required: false,
      default: false
    },
    orderId: {
      type: String,
      default: '',
    },
    isListingPage: {
      type: Boolean,
      default: false,
    },
    description: {
      type: [Object, Array],
      required: false,
      default: () => ({}),
    }
  },
  data () {
    return {
      productIds: null,
      loadingMore: false,
      lookedUpIds: [],
      page: 0,
      lastClickedSku: null,
      lastClickedProductIndex: 0,
      productClicked: false,
    }
  },
  computed: {
    ...mapGetters({
      getGbFeatureValue: 'growthbook/getGbFeatureValue',
    }),
    /**
     * Depending on the number of columns, we pass the 'mobileDisplayWidthOfViewportWidth' and 'desktopDisplayWidthOfViewportWidth'
     * props into the child component where we can apply them on images to get optimized image sizes
     */
    mobileDisplayWidthOfViewportWidth () {
      return 100 / parseInt(this.mobileColumns)
    },
    desktopDisplayWidthOfViewportWidth () {
      return 100 / parseInt(this.desktopColumns)
    },
    selectedFilters () {
      return this.requestFacetFilters.filter(x => x.facetName !== 'categories.uri')
    },
    productsViewed () {
      return '<strong>' + this.viewedProducts + '</strong>'
    },
    productsTotal () {
      return '<strong>' + this.totalProducts + '</strong>'
    },
    crumbs () {
      if (!this.pageName) {
        return null
      }
      return [
        {
          position: 1,
          name: this.$t('Global_Home'),
          url: this.$u('')
        },
        {
          position: 2,
          name: this.pageName,
          url: this.$route.path
        }
      ]
    },
    GBOldFilterDesign () {
      return this.getGbFeatureValue('filter:old-filter-design')
    },
  },
  mounted () {
    this.addPlaceholderElements()
  },
  beforeUpdate () {
    this.scrollPos = window.scrollY
  },
  updated () {
    window.scrollTo({ left: 0, top: this.scrollPos })
    this.addPlaceholderElements()
  },
  methods: {
    ...mapActions({
      loadMore: 'algolia/loadMore',
      resetFilters: 'algolia/resetFilters',
      toggleFacet: 'algolia/toggleFacet',
      lastClickedQueryID: 'ui/lastClickedQueryID',
      showMobileFilter: 'ui/showMobileProductFilter',
    }),
    barWidthCss () {
      const percent = (this.viewedProducts / this.totalProducts) * 100
      return { width: (percent.toString()) + '%' }
    },
    getFilteredLabel (value) {
      return value.includes('||') ? value.split('||')[0] : value
    },
    productClickTrigger (clickedProduct, index) {
      this.lastClickedSku = clickedProduct
      this.lastClickedProductIndex = index
      this.lastClickedQueryID(this.queryID)
      this.productClicked = true
    },
    addPlaceholderElements () {
      const productsWrapperElement = this.$refs.productsWrapper
      const numberOfElements = productsWrapperElement.children.length
      if (!this.isListingPage || numberOfElements < 5 || productsWrapperElement.getElementsByClassName('placeholder-wrapper').length > 0) {
        return
      }
      let startingOfLoop = numberOfElements - 2
      if (numberOfElements % 2 !== 0) {
        startingOfLoop = numberOfElements - 1
      }
      for (let i = startingOfLoop; i >= 1; i -= 2) {
        const element = productsWrapperElement.children[i]
        const placeholderWrapper = document.createElement('div')
        placeholderWrapper.classList.add('placeholder-wrapper')
        const placeholderElement = document.createElement('div')
        placeholderElement.classList.add(('placeholder-' + i))
        placeholderWrapper.appendChild(placeholderElement)
        productsWrapperElement.insertBefore(placeholderWrapper, element)
      }
    },
  }
}
